import classes from './PlusMinusInput.module.css'

const PlusMinusInput = (props) => {
  //value
  //onMinusClick
  //onPlusClick

  return (
    <div className={classes.inputGroup}>
      <input
        type="button"
        className={`${classes.buttonMinus} ${classes.buttonPointer} ${classes.inputs} ${classes.minusIcon}`}
        data-field="quantity"
        onClick={props.onMinusClick}
      />

      <input
        max=""
        value={props.value}
        name="quantity"
        readOnly
        className={`${classes.quantityField}  ${classes.inputs}`}
      />
      <input
        type="button"
        className={`${classes.buttonPlus} ${classes.buttonPointer}  ${classes.inputs} ${classes.plusIcon}`}
        data-field="quantity"
        onClick={props.onPlusClick}
      />
    </div>
  )
}

export default PlusMinusInput
